<template>
  <div class="wall-surface-area__table-wrap">
    <!-- header-row -->
    <div class="surface-area__table-header-row">
      <div class="table-headers" style="width:10%">Orientation</div>
      <div class="table-headers" style="width:30%">%Door area orientation-wise</div>
      <div class="table-headers" style="width:20%">Opening area (sq M)</div>
      <div class="table-headers" style="width:20%">Opaque area (100%)</div>
      <div class="table-headers" style="width:20%">Openable area (90%)</div>
    </div>
    <!-- data-rows -->
    <div v-for="(door, orientationIndex) in step3C.doorArrObj" :key="orientationIndex" class="data-row-wrap">
      <!-- <div class="data-field data-label">N</div> -->
      <template v-if="schema.inputs.step3A.wallSurfaceAreaArrObj[orientationIndex].calcWallArea !== 0">
        <div class="data-field">
          <div class="wall-direction">
            <span style="width:10%"> {{ door.orientation }}</span>
          </div>
        </div>
        <div class="data-field wwr-orientation">
          <v-text-field style="width:20%" outlined dense type="number" suffix="%" v-model="door.inputWwrOrientationPercent" placeholder="Enter "> </v-text-field>
          <!-- <lv-input type="number" v-model="door.inputWwrOrientationPercent" outlined placeholder="Enter ">
            <template #append>
              %
            </template>
          </lv-input> -->
        </div>
        <div class="data-field">
          <div style="width:20%">{{ door.calcOpeningArea }}</div>
        </div>
        <div class="data-field">
          <div style="width:20%">{{ door.calcOpaqueArea }}</div>
        </div>
        <div style="width:25%" class="data-field">
          <!-- <lv-input type="number" disabled outlined placeholder="0.00" v-model="orientation.calcWallArea" /> -->
          <div style="width:20%;">{{ door.calcOpenableArea }}</div>
          <div style="width:5%;">
            <v-checkbox v-model="door.checkedOpenableArea"></v-checkbox>
          </div>
        </div>
      </template>
    </div>
    <hr />
    <div class="step-3C__summary">
      <div class="summary-head">Summary:</div>
      <div class="summary-block__wrap">
        <div class="summary-field__row">
          <div class="sumarry-field__label">Total opening area :<span class="units">(sq.M)</span></div>
          <div class="summary-field__value">{{ step3C.summary_door_openable.total_opening_area }}</div>
        </div>
        <div class="summary-field__row">
          <div class="sumarry-field__label">Total opaque area :<span class="units">(sq.M)</span></div>
          <div class="summary-field__value">{{ step3C.summary_door_openable.total_opaque_area }}</div>
        </div>
        <div class="summary-field__row">
          <div class="sumarry-field__label">Total openable area :<span class="units">(sq.M)</span></div>
          <div class="summary-field__value">{{ step3C.summary_door_openable.total_openable_area }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LvInput from 'lightvue/input';
export default {
  components: {
    LvInput,
  },
  data() {
    return {
      fixedOpaquePercent: 100,
      fixedOpenablePercent: 90,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(step3A) {
        this.$store.dispatch('setStep3A', step3A);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3C) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
  },
  beforeUpdate() {
    this.calcDoorOpenableArea();
    this.calcTotalOpeningArea();
    this.calcTotalOpaqueArea();
    this.calcTotalOpenableArea();
  },
  methods: {
    calcDoorOpenableArea() {
      //  this.VentilatorOpeningArea = 0;
      for (let g = 0; g <= this.step3C.doorArrObj.length - 1; g++) {
        this.step3C.doorArrObj[g].calcOpeningArea = (this.step3C.doorArrObj[g].inputWwrOrientationPercent * 0.01 * 1 * this.step3A.wallSurfaceAreaArrObj[g].calcWallArea).toFixed(2);
        this.step3C.doorArrObj[g].calcOpaqueArea = (this.step3C.doorArrObj[g].inputWwrOrientationPercent * 0.01 * this.fixedOpaquePercent * 0.01 * this.step3A.wallSurfaceAreaArrObj[g].calcWallArea).toFixed(2);
        this.step3C.doorArrObj[g].calcOpenableArea = (this.step3C.doorArrObj[g].inputWwrOrientationPercent * 0.01 * this.fixedOpenablePercent * 0.01 * this.step3A.wallSurfaceAreaArrObj[g].calcWallArea).toFixed(2);
      }
    },
    calcTotalOpeningArea() {
      let totalOpeningArea = 0;
      for (let g = 0; g <= this.step3C.doorArrObj.length - 1; g++) {
        totalOpeningArea = totalOpeningArea + +this.step3C.doorArrObj[g].calcOpeningArea;
      }
      this.step3C.summary_door_openable.total_opening_area = totalOpeningArea.toFixed(2);
    },
    calcTotalOpaqueArea() {
      let totalOpaqueArea = 0;
      for (let g = 0; g <= this.step3C.doorArrObj.length - 1; g++) {
        totalOpaqueArea = totalOpaqueArea + +this.step3C.doorArrObj[g].calcOpaqueArea;
      }
      this.step3C.summary_door_openable.total_opaque_area = totalOpaqueArea.toFixed(2);
    },
    calcTotalOpenableArea() {
      let totalOpenableArea = 0;
      for (let k = 0; k <= this.step3C.doorArrObj.length - 1; k++) {
        if (this.step3C.doorArrObj[k].checkedOpenableArea) {
          totalOpenableArea = totalOpenableArea + +this.step3C.doorArrObj[k].calcOpenableArea;
        }
      }
      this.step3C.summary_door_openable.total_openable_area = totalOpenableArea.toFixed(2);
    },
  },
};
</script>

<style lang="scss">
.surface-area__table-header-row {
  display: flex;
  width: 100%;
  background-color: #dedede;
  .table-headers {
    color: #343f4b;
    padding: 12px;
    font-size: 16px;
    align-items: unset;
    // width: 33.33%;
  }
}
.data-row-wrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 8px 12px 4px 12px;
  align-items: center;
  //   align-items: center;
  .data-field {
    // width: 25%;
    text-align: center;
    // align-items: unset;

    .wall-direction {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    // text-align: center;
  }
}
.wwr-orientation {
  .lv-input__field {
    .lv-input__append {
      margin-left: -124px;
      padding: 8px;
    }
  }
}
</style>
